import ResponseTemplate from './ResponseTemplate.js'

/**
 * @class
 * @implements ResponseTemplate
 */
export default class DraftIdResponseTemplate extends ResponseTemplate {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.id
   */

  build() {
    return {
      id: 23
    }
  }
}
